var _symbol, _symbol2, _symbol3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    style: {
      position: "absolute",
      width: 0,
      height: 0,
      overflow: "hidden"
    },
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("symbol", {
    id: "icon-Logo",
    viewBox: "0 0 35 32"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb627",
    style: {
      fill: "var(--color1, #ffb627)"
    },
    d: "M23.748 4.297c-2.314-0.553-4.628-1.66-6.364-3.32-1.736 1.66-4.050 2.767-6.364 3.32 0.579 4.981 2.314 8.301 6.364 11.068 4.050-2.767 6.364-6.087 6.364-11.068z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color2, #fbfbfb)"
    },
    d: "M21.433 24.903l-16.2-18.262v8.854l12.728 13.835 3.471-4.427z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color2, #fbfbfb)"
    },
    d: "M23.169 23.243l6.943-7.748v-8.301l-10.993 12.175 4.050 3.874z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color2, #fbfbfb)"
    },
    d: "M23.748 26.010v4.981l6.364-7.194v-4.981l-6.364 7.194z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fbfbfb",
    style: {
      fill: "var(--color2, #fbfbfb)"
    },
    d: "M11.598 26.010l-6.364-7.194v4.981l6.364 7.194v-4.981z"
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-currency_bcg",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.053 0c-2.791 0-5.053 2.262-5.053 5.053v21.895c0 2.79 2.262 5.053 5.053 5.053h21.895c2.79 0 5.053-2.262 5.053-5.053v-21.895c0-2.791-2.262-5.053-5.053-5.053h-21.895zM13.265 13.136c0 0.995 0.765 1.635 3.144 2.253s4.925 1.635 4.925 4.61c0 2.148-1.624 3.332-3.667 3.72v2.253h-3.143v-2.274c-2.012-0.43-3.73-1.718-3.856-4.013h2.305c0.115 1.236 0.964 2.2 3.123 2.2 2.316 0 2.829-1.153 2.829-1.876 0-0.974-0.524-1.896-3.143-2.525-2.923-0.702-4.925-1.907-4.925-4.327 0-2.022 1.635-3.342 3.667-3.783v-2.263h3.143v2.295c2.19 0.534 3.29 2.19 3.363 3.992h-2.316c-0.063-1.31-0.754-2.2-2.619-2.2-1.771 0-2.829 0.796-2.829 1.938z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-home_bcg",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.053 0c-2.791 0-5.053 2.262-5.053 5.053v21.895c0 2.79 2.262 5.053 5.053 5.053h21.895c2.79 0 5.053-2.262 5.053-5.053v-21.895c0-2.791-2.262-5.053-5.053-5.053h-21.895zM13.418 17.987v6.902h-5.754v-9.203h-3.453l11.509-10.353 11.509 10.353h-3.453v9.203h-5.754v-6.902h-4.604z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-stat_bcg",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.053 0h21.895c2.79 0 5.053 2.262 5.053 5.053v21.895c0 2.79-2.262 5.053-5.053 5.053h-21.895c-2.791 0-5.053-2.262-5.053-5.053v-21.895c0-2.791 2.262-5.053 5.053-5.053zM24.842 13.941c1.081 0 1.965-0.926 1.965-2.058s-0.884-2.059-1.965-2.059c-1.081 0-1.965 0.926-1.965 2.059 0 0.185 0.020 0.36 0.069 0.525l-3.488 3.664c-0.157-0.051-0.334-0.072-0.511-0.072s-0.354 0.021-0.511 0.072l-2.505-2.624c0.049-0.165 0.069-0.35 0.069-0.535 0-1.132-0.884-2.058-1.965-2.058s-1.965 0.926-1.965 2.058c0 0.185 0.020 0.371 0.069 0.535l-4.48 4.683c-0.157-0.051-0.324-0.072-0.501-0.072-1.081 0-1.965 0.926-1.965 2.059s0.884 2.058 1.965 2.058 1.965-0.926 1.965-2.058c0-0.185-0.020-0.36-0.069-0.525l4.47-4.693c0.157 0.051 0.334 0.072 0.511 0.072s0.354-0.021 0.511-0.072l2.505 2.625c-0.049 0.165-0.069 0.35-0.069 0.535 0 1.132 0.884 2.059 1.965 2.059s1.965-0.926 1.965-2.059c0-0.185-0.020-0.371-0.069-0.535l3.498-3.654c0.157 0.051 0.324 0.072 0.501 0.072z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.3df88140045c353bfdd6b20e0756a4b1.svg";
export { ForwardRef as ReactComponent };